const isNotNullish = <T>(x: T): x is NonNullable<T> =>
  x !== null && x !== undefined;

export default isNotNullish;
